import { createAction } from 'redux-act';
import { types } from './types';

export const setPlayerVolume = createAction<number>(types.SET_PLAYER_VOLUME);
export const setPlayerQuality = createAction<string>(types.SET_PLAYER_QUALITY);
export const setPlayerSpeed = createAction<number>(types.SET_PLAYER_SPEED);
export const setMute = createAction<boolean>(types.SET_MUTE);
